import { OwnListService } from './../own-list.service';
import { ListHelper } from './../helpers/ListHelper';
import { Component, OnInit, ViewChild, OnDestroy, ɵpublishGlobalUtil, ElementRef, HostListener } from '@angular/core';
import { UrlValidator } from "../helpers/UrlValidater";
import { ActivatedRoute, Router } from "@angular/router";
import { DetailDataService } from "../detail-data.service";
import { Global } from "../classes/Global";
import { Cache } from "../classes/Cache";
import { BaseComponent } from "../classes/BaseComponent";
import { Location } from "@angular/common";
import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { ValidationHelper } from '../helpers/ValidationHelper';
import { PriceHelper } from '../helpers/PriceHelper';
import { Config } from '../classes/Config';
import { StorageHelper } from '../helpers/StorageHelper';
import { WishlistService } from '../wishlist.service';
import { BaseService } from '../classes/BaseService';
import { Log } from '../helpers/Log';
import { DateHelper } from '../helpers/DateHelper';
import { GraphData } from '../graph/graph.component';
import * as Bowser from 'bowser';
import { StringHelper } from '../helpers/StringHelper';
import { SeoService } from '../seo.service';
import { ThemeService } from '../theme.service';
import { Subscription } from 'rxjs';
import { Observable } from 'rxjs';
import { CustomMap } from '../multipick-dropdown/multipick-dropdown.component';
import { BlocklistService } from '../blocklist.service';
import { Platform } from '@angular/cdk/platform';
import { PriceAlertModalComponent, PriceAlertSettings } from '../price-alert-modal/price-alert-modal.component';
import { ToastService } from '../toast/toast.service';
import { AiStructuredDataHelper } from '../helpers/AiStructuredDataHelper';

//NEUES FEATZRE: beim senden von emails müssen wir auch best price anzeigen nict nur preissenkung!

interface BundleOwnershipInfo {
  ownedCount: number;
  totalCount: number;
  missingCount: number;
  pricePerMissingMovie: string;
  bundlePrice: string;
  totalSeparatePrice: string;
}

@Component({
  selector: 'app-detail-view',
  templateUrl: './detail-view.component.html',
  styleUrls: ['./detail-view.component.scss'],
  providers: [DetailDataService, WishlistService, OwnListService, BlocklistService]
})
export class DetailViewComponent extends BaseComponent implements OnInit, OnDestroy {

  item;
  highResImageLoaded = false;
  store: string;
  country: string;
  showLoading = false;
  trailerSource = "";
  itemType = "";
  fullscreenGalleryIsOn = false;
  showBigCover = false;
  fullscreenGalleryPosition = 0;
  showHDIcon = false;
  isToBuy: boolean = true;
  showPlaceHolder: boolean = false;
  canGoBack: boolean = false;
  priceTrendLegendVisible: boolean = false;
  isMobile: boolean = false;
  requestLoaded: boolean = false;
  navigationSubscription: Subscription;
  priceEvoDataForGraph: GraphData = null;
  priceInsight: { message: string, cssClass: string } | false | null = null;
  bundleOwnershipInfo: BundleOwnershipInfo | null = null;

  // Price alert settings
  priceAlertSettings: PriceAlertSettings | null = null;

  // Cached display price for price alert (updated after save)
  priceAlertDisplayPriceCache: string = '---';
  // Cached prices array for price alert card (prevents flickering on scroll)
  priceAlertPricesCache: { quality: string, price: string }[] = [];
  // Whether the price alert is for rental (from wishlist v2 API)
  priceAlertIsRental: boolean = false;

  // Cached list states - updated only when item changes or list actions occur
  inWishlist: boolean = false;
  inOwnlist: boolean = false;
  inBlocklist: boolean = false;

  // Loading states for wishlist/ownlist buttons
  wishlistLoading: boolean = false;
  ownlistLoading: boolean = false;
  // Spinner visibility (delayed by 1 second)
  wishlistSpinnerVisible: boolean = false;
  ownlistSpinnerVisible: boolean = false;
  // Loading state for price alert save
  priceAlertSaving: boolean = false;

  @ViewChild('authentication', {static: false}) authentication;
  @ViewChild('moreDDContent', {static: false}) moreDDContent: ElementRef;
  @ViewChild('popupContent', { static: false }) popupContent: ElementRef;
  @ViewChild('priceAlertModal', { static: false }) priceAlertModal: PriceAlertModalComponent;

  schema;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private detailDataService: DetailDataService,
    private wishlistService: WishlistService,
    private location: Location,
    private seoService: SeoService,
    private ownlistService: OwnListService,
    private themeService: ThemeService,
    private blocklistService: BlocklistService,
    private platform: Platform,
    private toastService: ToastService
  ) {
    super();
  }

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (event && event.target) {
      try {
    // Handle different className types: string, DOMTokenList, or SVGAnimatedString
        // Wrap in try-catch to handle cross-origin iframe elements that may throw permission errors
        const className = event.target.className;
        if (className) {
          let classNameString = '';
          if (typeof className === 'string') {
            classNameString = className;
          } else if (className && typeof className === 'object') {
            // Handle DOMTokenList or SVGAnimatedString
            if (className.baseVal !== undefined) {
              // SVGAnimatedString
              classNameString = className.baseVal || '';
            } else if (typeof className.toString === 'function') {
              // DOMTokenList
              classNameString = className.toString();
            }
          }

          if (classNameString && classNameString.indexOf("dd-click") == -1 && this.moreDDContent) {
            this.closeDropdown(this.moreDDContent);
          }
        }
      } catch (e) {
      // Ignore permission errors from cross-origin iframes or restricted contexts
      // This is expected behavior when clicking on elements from different origins
      }
    }
  }

  ngOnInit() {

    this.isMobile = this.platform.ANDROID || this.platform.IOS;
    this.canGoBack = history && history.state && history.state['navigationId'] && history.state['navigationId'] > 1;

    UrlValidator.validateDetailViewUrl(this.route, this.router);

    //Get the additional listType parameter
    this.navigationSubscription = this.route.params.subscribe(params => {
      const itemId = params['id'];
      this.country = params['country'];
      this.store = params['store'];
      if(this.store == "google-play") { this.store = Global.GOOGLEPLAY; }
      const slug = params['slug'];
      // Canonical will be set properly after data loads with alternateLocalizationData
      // For now, only handle the "no slug" case (remove canonical)
      if (!slug) {
        this.seoService.createCanonicalLink("");
      }

      //load short wishlist & ownlist
      const token = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
      const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist);
      const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist);
      if(token) {
        if(!shortOwnlist || !shortOwnlist[this.store]) {
          this.updateLocalShortOwnlist(token);
        }
        if(!shortWishlist) {
          this.updateLocalShortWishlist(token);
        }
      }

      //The iOS app gives a wrong url with the country like 'en_us' or 'de_de'
      //So here I only take the second part when its the case
      if (this.country && this.country.length > 2) {
        const parts = this.country.split('_');
        if (parts && parts.length >= 2) {
          this.country = parts[1];
        }
      }

      //Little conversion for the sweet sweet API
      this.itemType = Global.getMediaTypeForDetailView();
      this.item = null;
      this.priceEvoDataForGraph = null;
      this.loadData(this.itemType, itemId).subscribe(res => {
        this.showLoading = false;

        if (res.results && res.results[this.itemType]) {
          this.item = res.results[this.itemType];
          this.updateListStates();
          this.getPricePerMovie();
          this.priceEvoDataForGraph = this.getPriceEvoDataForGraph();
          this.showHDIcon = !this.item.has4K && this.item.priceHd;
          this.priceInsight = this.calculatePriceInsight();
          this.updatePriceAlertDisplayCache();

          if (this.item && this.item.title) {

            if(this.item.summary) {
              this.item.summary = new String(this.item.summary).replace(/<br \/>/g, "\n");
              this.item.summary = new String(this.item.summary).replace(/<i>/g, "");
              this.item.summary = new String(this.item.summary).replace(/<\/i>/g, "");
              this.item.summary = new String(this.item.summary).replace(/<b>/g, "");
              this.item.summary = new String(this.item.summary).replace(/<\/b>/g, "");
              this.item.summary = new String(this.item.summary).replace(/<.+>/g, "");
              this.item.summary = new String(this.item.summary).replace(/<.+\/>/g, "");
              this.item.summary = new String(this.item.summary).replace(/&#.+;/g, "");
              this.item.summary = new String(this.item.summary).replace(/&amp;/g, "&");
            }

            let title = "";
            let store = this.store;
            if(store == "amazon") { store = "primeVideo"; }
            if(this.item.title.length > 36) {
              title = StringHelper.format(this.getString('detailViewMetaTitle4'), this.item.title.substr(0, 36), this.getString(store));
            }
            else if(this.item.title.length > 29) {
              title = StringHelper.format(this.getString('detailViewMetaTitle3'), this.item.title, this.getString(store));
            }
            else if(this.item.title.length > 15) {
              title = StringHelper.format(this.getString('detailViewMetaTitle2'), this.item.title, this.getString(store));
            }
            else {
              title = StringHelper.format(this.getString('detailViewMetaTitle1'), this.item.title, this.getString(store));
            }

            this.seoService.setTitle(title);
            this.seoService.setMetaDescription(StringHelper.format(this.getString('detailViewMetaDesc'), this.item.title, this.getString(this.store)));
            this.seoService.setMetaKeywords(StringHelper.format(this.getString('detailViewMetaKeywords'), this.item.title, this.itemType));
            this.seoService.setOGImage(this.getImageSrc());
            this.seoService.setOGUrl(Config.frontendUrl + this.router.url);
            this.seoService.setHrefLangTagsForDetailView(this.item.alternateLocalizationData);
            this.seoService.setCanonicalForDetailView(this.item.alternateLocalizationData);
            this.buildSchema();

            // Set noindex for unavailable items or non-indexable countries, otherwise allow indexing
            if (this.item.itemStatus === 'notAvailable' || !this.seoService.isIndexableCountry()) {
              this.seoService.setNoIndex(true);
            } else {
              this.seoService.setNoIndex(false);
            }
          }
          else {
            this.seoService.setNoIndex(true);
          }
        }
        else {
          this.seoService.setNoIndex(true);
        }
        this.requestLoaded = true;
      }, err => {
        Log.getInstance().d(err);
        this.showLoading = false;
        this.requestLoaded = true;
        this.seoService.setNoIndex(true);
      });

    });

  }

  /** @deprecated Use inBlocklist property instead for template bindings */
  isInBlocklist(): boolean {
    return this.inBlocklist;
  }

  /** Updates cached list states - call this when item changes or after list modifications */
  updateListStates(): void {
    if (!this.item) {
      this.inWishlist = false;
      this.inOwnlist = false;
      this.inBlocklist = false;
      this.bundleOwnershipInfo = null;
      return;
    }
    this.inWishlist = ListHelper.isItemInWishlist(this.item, this.store);
    this.inOwnlist = ListHelper.isItemInOwnlist(this.item);
    this.inBlocklist = ListHelper.isItemInBlocklist(this.item, this.store);
    this.updateBundleOwnershipInfo();
  }

  moreClicked() {
    if (this.moreDDContent && this.moreDDContent.nativeElement) {
      if (this.moreDDContent.nativeElement.classList.contains('dd-open')) {
        this.closeDropdown(this.moreDDContent);
      }
      else {
        this.openDropdown(this.moreDDContent);
      }
    }
  }

  closeDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-close';
    }
  }

  openDropdown(dropdownRef: ElementRef) {
    if (dropdownRef && dropdownRef.nativeElement) {
      dropdownRef.nativeElement.className = 'dropdown-content dd-open';
    }
  }

  getShortBlocklist() {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);

    if (sessionToken){
      this.blocklistService.getShortBlocklist(
        Global.getCountry(),
        Global.getStore(),
        sessionToken
      ).subscribe(res => {
        if (res && res['results']) {
          const shortBlocklist = StorageHelper.getInstance().get(StorageHelper.keys.shortBlocklist) || {};
          shortBlocklist[Global.getStore()] = res["results"];
          const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortBlocklist, shortBlocklist);
          if (saved) {
            ListHelper.clearBlocklistCache();
            // Update UI state after blocklist changes
            this.updateListStates();
          } else {
            Log.getInstance().d('Failed to save blocklist to storage - storage may be full');
          }
        }

      },
      err => {
        Log.getInstance().d(err);
      });
    }

  }

  addToBlocklist() {

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if(sessionToken) {
      this.blocklistService.addItem(
        this.country, this.store,
        Global.getMediaType(),
        sessionToken,
        this.item.idInStore
      ).subscribe(() => {
        this.getShortBlocklist();
      });
    }
    else {
      this.authentication.openRegister();
    }

    this.closeDropdown(this.moreDDContent);
  }

  removeFromBlocklist() {

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if(sessionToken) {
      this.blocklistService.removeItem(
        this.country, this.store,
        Global.getMediaType(),
        StorageHelper.getInstance().get(StorageHelper.keys.sessionToken),
        this.item.idInStore
      ).subscribe(() => {
        this.getShortBlocklist();
      });
    }
    else {
      this.authentication.openRegister();
    }

    this.closeDropdown(this.moreDDContent);
  }

  buildSchema() {
    this.schema = {
      '@context': 'http://schema.org',
      '@type': Global.getSchemaType(),
      'name': this.item.title,
      'dateCreated': this.item.releaseDate,
      'image': this.getImageSrc(),
      'description': this.item.summary,
      'inLanguage': this.item.audiotracks,
      'subtitleLanguage': this.item.subtitles,
      'genre': this.item.primaryGenreName,
      'awards': this.item.awards,
      'productionCompany': this.item.studio,
      'duration': this.getRunningTime(),
      'contentRating': this.item.advisoryRating,
      'offers': {
        '@type': 'Offer',
        'category': Global.getSchemaType(),
        'availableDeliveryMethod': 'http://purl.org/goodrelations/v1#DeliveryModeDirectDownload',
        'name': this.item.title,
        'image': this.getImageSrc(),
        'description': this.item.summary,
        'url': this.item.productPageUrl,
        'eligibleRegion': Global.getCountry(),
        'offeredBy': {
          '@type': 'Organization',
          'name': Global.getStore()
        },
        'seller': {
          '@type': 'Organization',
          'name': Global.getStore()
        },
        'price': parseFloat(PriceHelper.getCurrentDetailViewPrice(this.item, this.isToBuy).replace(/[^0-9^\.,]/g, '').replace(',','.')),
        'priceCurrency': this.item.currency
      }
    };

    if(this.item.itemType == 'album' || this.item.itemType == 'single') {
      this.schema["byArtist"] = {
        "@type": "MusicGroup",
        "name": this.item.artist
      }
    }

    if(this.item.itemType == 'album') {
      this.schema['albumReleaseType'] = "http://schema.org/AlbumRelease";
      this.schema["albumProductionType"] = "http://schema.org/StudioAlbum";
      if(this.item.childSingles) {
        this.schema['numTracks'] = this.item.childSingles.length;
        this.schema["track"] = {
          "@type": "ItemList",
          "numberOfItems": this.item.childSingles.length,
          "itemListElement": this.item.childSingles.map((x,index) => {
              return {
                '@type': 'ListItem',
                'position': index+1,
                'item': {
                  '@type': 'MusicRecording',
                  'name': x.title,
                  'url': x.productPageUrl
                }
              };
          })
        };
      }

    }
    else if(this.item.itemType == 'single') {
      if(this.item.parentAlbum) {
        this.schema['inAlbum'] = {
          '@type': 'MusicAlbum',
          'albumReleaseType': 'http://schema.org/AlbumRelease',
          'albumProductionType': 'http://schema.org/StudioAlbum',
          'name': this.item.parentAlbum.title,
          'url': this.item.parentAlbum.productPageUrl
        };
      }
    }

    if(this.item.itemType == 'ebook') {
      this.schema['bookFormat'] = 'http://schema.org/EBook';
      this.schema['author'] = {'@type':'Person', 'name': this.item.artist};
    }

    if(this.item.itemType == 'app' || this.item.itemType == 'macapp') {
      this.schema['applicationCategory'] = this.item.primaryGenreName;

      if(this.item.plattform != null) {
        switch(this.item.plattform) {
          case "1":
          this.schema['availableOnDevice'] = 'iPhone';
          this.schema['operatingSystem'] = 'iOS';
          break;
          case "2":
          this.schema['availableOnDevice'] = 'iPad';
          this.schema['operatingSystem'] = 'iOS';
          break;
          case "3":
          this.schema['availableOnDevice'] = 'Mac';
          this.schema['operatingSystem'] = 'MacOS';
          break;
          default:
            this.schema['operatingSystem'] = 'iOS & MacOS';
          break;
        }
      }

      this.schema['fileSize'] = this.getFileSize(this.item.fileSize);
      this.schema['softwareVersion'] = this.item.appVersion;
      this.schema['author'] = {
        '@type': 'Organization',
        'name': this.item.vendorName
      };
    }

    if(this.item.episodeCount) {
      this.schema['numberOfEpisodes'] = this.item.episodeCount;
    }

    if(this.item.episodes) {
      this.schema['episode'] = this.item.episodes.map((x, index) => {
        return {
          '@type': 'Episode',
          'name': x.title,
          'abstract': x.summary,
          'episodeNumber': index+1,
          'url': x.productPageUrl
        };
      });
    }

    if(this.item.directors) {
      this.schema['director'] = this.item.directors.map(x => { return {'@type':'Person', 'name': x.name}; });
    }

    if(this.item.actors) {
      this.schema['actor'] = this.item.actors.map(x => { return {'@type':'Person', 'name': x.name}; });
    }

    if(this.item.writers) {
      this.schema['author'] = this.item.writers.map(x => { return {'@type':'Person', 'name': x.name}; });
    }

    if(this.item.reviews) {
      this.schema['aggregateRating'] = {
        '@type': 'AggregateRating',
        'ratingCount': this.item.reviews.length,
        'reviewCount': this.item.reviews.length,
        'worstRating': 1,
        'bestRating': 10,
        'ratingValue': (this.item.reviews.reduce((prev, curr) => { return (prev||10) + (curr||10); }) / this.item.reviews.length) || 10
      };
      this.schema['review'] = this.item.reviews.map(x => {
        return {
        '@type': 'Review',
        'author': x.username,
        'reviewBody': x.text,
        'reviewRating': {
          'author': x.username,
          'worstRating': 1,
          'bestRating': 10,
          'ratingValue': x.rating || 10
        }
      }; });
    }

    this.schema['potentialAction'] = AiStructuredDataHelper.buildDetailPotentialAction(this.country, this.store, this.item);

  }

  getStudioLink(): string[] {
    const studios: CustomMap[] = Config.studios.map(x => {
      if(x.id) {
        return { key: x.id, value: x.title };
      }
      else {
        return { key: x, value: x }
      }
    });
    let studio = studios.filter(x => x.value == this.item.studio || x.key == this.item.studio)[0];
    if(!studio) {
      //the studio is not in the frontend list but we want a link to search for it anyway
      studio = { key: this.item.studio, value: this.item.studio };
    }
    return ["/", Global.getCountry(), Global.getStore(), Global.getMediaTypeForUrl(), "studios", String(studio.key)];
  }

  onBuyChanged(buy: boolean) {
    this.isToBuy = buy;
    // Update graph data when switching between buy/rent
    if (this.item) {
      this.getPricePerMovie();
      this.priceEvoDataForGraph = this.getPriceEvoDataForGraph();
    }
  }

  getPricePerMovie() {
    if (this.item) {
      let price = 0;
      if (PriceHelper.hasSdPrice(this.item, this.isToBuy) && !PriceHelper.hasHdPrice(this.item, this.isToBuy)) {
        price = this.isToBuy ? this.item.priceSd : this.item.rentalPriceSd;
      }
      else if (PriceHelper.hasHdPrice(this.item, this.isToBuy)) {
        price = this.isToBuy ? this.item.priceHd : this.item.rentalPriceHd;
      }
      else if (PriceHelper.has4kPrice(this.item, this.isToBuy)) {
        price = this.isToBuy ? this.item.price4k : this.item.rentalPrice4k;
      }
      if (this.isMovieBundleDetail() && price != 0) {
        this.item.pricePerMovie = PriceHelper.formatPrice(price / this.item.childMovies.length, this.item.currency);
      }
      else {
        this.item.pricePerMovie = null;
      }
    }
  }

  updateBundleOwnershipInfo(): void {
    this.bundleOwnershipInfo = null;

    if (!this.shouldShowBundleOwnershipInfo()) {
      return;
    }

    const childMovies = this.item.childMovies;
    let ownedCount = 0;
    const missingMovies = [];

    for (let i = 0; i < childMovies.length; i++) {
      const movie = childMovies[i];
      if (ListHelper.isItemInOwnlist(movie, this.store)) {
        ownedCount++;
      }
      else {
        missingMovies.push(movie);
      }
    }

    const totalCount = childMovies.length;
    const missingCount = missingMovies.length;

    if (ownedCount === 0 || ownedCount === totalCount || missingCount === 0) {
      return;
    }

    const bundlePrice = this.getPreferredBundleOwnershipPrice(this.item);
    const pricePerMissingMovie = bundlePrice / missingCount;
    let totalSeparatePrice = 0;

    for (let i = 0; i < missingMovies.length; i++) {
      totalSeparatePrice += this.getPreferredBundleOwnershipPrice(missingMovies[i]);
    }

    this.bundleOwnershipInfo = {
      ownedCount: ownedCount,
      totalCount: totalCount,
      missingCount: missingCount,
      pricePerMissingMovie: this.formatBundleOwnershipPrice(pricePerMissingMovie),
      bundlePrice: this.formatBundleOwnershipPrice(bundlePrice),
      totalSeparatePrice: this.formatBundleOwnershipPrice(totalSeparatePrice)
    };
  }

  shouldShowBundleOwnershipInfo(): boolean {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken || !this.storeIsItunes() || !this.item) {
      return false;
    }

    return this.isMovieBundleDetail();
  }

  isMovieBundleDetail(): boolean {
    if (!this.item || !this.item.childMovies || this.item.childMovies.length === 0) {
      return false;
    }

    return this.isTruthyFlag(this.item.isMovieBundle) ||
      (this.isTruthyFlag(this.item.isBundle) && this.item.itemType === 'movie');
  }

  getPreferredBundleOwnershipPrice(item): number {
    if (!item) {
      return 0;
    }

    const hdPrice = this.getPositiveNumber(item.priceHd);
    if (hdPrice > 0) {
      return hdPrice;
    }

    const sdPrice = this.getPositiveNumber(item.priceSd);
    if (sdPrice > 0) {
      return sdPrice;
    }

    return 0;
  }

  formatBundleOwnershipPrice(price: number): string {
    return PriceHelper.formatPrice(price.toFixed(2), this.item.currency, true, true);
  }

  getPositiveNumber(value): number {
    if (value === null || value === undefined || value === '') {
      return 0;
    }

    const price = parseFloat(('' + value).replace(',', '.'));
    if (isNaN(price) || price <= 0) {
      return 0;
    }

    return price;
  }

  isTruthyFlag(value): boolean {
    return value === true || value === 1 || value === '1';
  }

  getImageSrc() {
    if (!this.useIvan() || !this.storeIsItunes()) {
      return this.getHttpsImageUrl();
    }
    else if (this.useIvan() && this.storeIsItunes()) {
      return this.getItemImageUrl(false);
    }
    return "";
  }

  getHttpsImageUrl() {
    const url = this.item.imageLargeUrl || this.item.itemImageURL || this.item.imageMediumUrl || '';
    return StringHelper.getImageHttpsUrl(url);
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  getExpectedReleaseDate() {
    return this.item.releaseDate ? DateHelper.serverDateToLocaleDate(this.item.releaseDate) : this.getString('unknown');
  }

  loadData(mediaType, itemId): Observable<any> {
    this.showLoading = true;
    return this.detailDataService.getDetailData(this.store, this.country, mediaType, itemId);
  }

  getItemImageUrl(bigCover: boolean): string {

    if (!this.item) {
      return "";
    }

    const size = bigCover ? "/800x800.jpg" : "/400x400.jpg";

    const id = this.item.idInStore || this.item.itemID;
    if (id) {
      return Config.imageServerUrl + this.country + "/" + id + size;
    }
    return "";
  }

  back() {
    this.location.back();
  }

  getFullscreenGalleryImages() {
    if (this.useIvan() && this.storeIsItunes()) {
      return this.getItemImageUrl(true);
    }
    else if(this.item) {
      return this.getHttpsImageUrl();
    }
    return '';
  }

  getReleaseYear() {
    if (this.item.releaseDate) {
      const year = this.item.releaseDate.toString().split('-')[0];

      if(!this.item.title.includes(year)) {
        return year;
      }
      else {
        return "";
      }

    }
    return "";
  }

  getRunningTime(): string {
    let runningTime = this.item.runningTime;
    //Sometimes, the runningTime for movies is in minutes, sometimes its in seconds...
    //If it's bigger than 500, we can say it's in seconds. 500 seconds = 8min
    if (this.item.itemType === "movie" && runningTime < 500) {
      //Do nothing, already in minutes
    }
    else {
      runningTime /= 60;
    }
    runningTime = Math.floor(runningTime);
    if (!isNaN(runningTime) && runningTime > 0) {
      return runningTime + "min";
    }
    return "";
  }

  getTurned4K(): string {
    let dateString;

    if (this.item.turned4K) dateString = this.item.turned4K;
    else dateString = this.item.releaseDate;

    if (dateString) return DateHelper.serverDateToLocaleDate(dateString);

    return "";
  }

  getTurned3D(): string {
    let dateString;

    if (this.item.turned3D) dateString = this.item.turned3D;
    else dateString = this.item.releaseDate;

    if (dateString) return DateHelper.serverDateToLocaleDate(dateString);

    return "";
  }

  isPlatformDesktop(): boolean {
    const bowser = Bowser.getParser(navigator.userAgent);
    return bowser.is("desktop");
  }

  getPriceEvolution(): string {
    if (!this.item) return '';

    const mediaType = Global.getMediaType();
    const isMoviesOrRental = mediaType === Global.MOVIES || mediaType === Global.BUYMOVIES || mediaType === Global.RENTALMOVIES;

    if (isMoviesOrRental) {
      // Use same logic as price-information component to determine which evolution data to use
      if (PriceHelper.hasSdPrice(this.item, this.isToBuy) && !PriceHelper.hasHdPrice(this.item, this.isToBuy)) {
        return this.isToBuy ? this.item.priceSdEvolution : this.item.rentalPriceSdEvolution;
      } else if (PriceHelper.hasHdPrice(this.item, this.isToBuy)) {
        return this.isToBuy ? this.item.priceHdEvolution : this.item.rentalPriceHdEvolution;
      } else if (PriceHelper.has4kPrice(this.item, this.isToBuy)) {
        return this.isToBuy ? this.item.price4kEvolution : this.item.rentalPrice4kEvolution;
      } else if (PriceHelper.hasPrice(this.item, this.isToBuy)) {
        return this.isToBuy ? this.item.priceEvolution : this.item.rentalPriceEvolution;
      }
    } else {
      // For other media types, check if rental prices exist and use them if isToBuy is false
      if (!this.isToBuy && this.item.rentalPriceEvolution) {
        return this.item.rentalPriceEvolution;
      }
      return this.item.priceEvolution || this.item.priceHdEvolution || this.item.priceSdEvolution || "";
    }
    return '';
  }

  getBuyButtonImageUrl(): string {
    let twoLetterCode = InternationalizationHelper.getTwoCharactersLanguage();

    if (this.store === "itunes") {
      if (twoLetterCode == "es") twoLetterCode = "en"

      if(this.mediaIsMusic()) {
        return "./assets/images/buy_on_iTunes_" + twoLetterCode + ".png";
      }
      if (Global.getMediaType() == Global.TV || Global.getMediaType() == Global.SEASONS) {
        if (this.item.productPageUrl.includes("itunes.apple.com")) {
          return "./assets/images/buy_on_iTunes_" + twoLetterCode + ".png";
        }
        else {
          return "./assets/images/get_it_on_appletv_" + twoLetterCode + ".png";
        }
      }

      if (Global.getMediaType() == Global.BUYMOVIES || Global.getMediaType() == Global.RENTALMOVIES || Global.getMediaType() == Global.SEASONS) {
        return "./assets/images/get_it_on_appletv_" + twoLetterCode + ".png";
      }
      if(Global.getMediaType() == Global.EBOOKS || Global.getMediaType() == Global.AUDIOBOOKS) {
        return "./assets/images/get_it_on_iTunes_books_" + twoLetterCode + ".png";
      }
      if(Global.getMediaType() == Global.APPS || Global.getMediaType() == Global.MACAPPS) {
        return "./assets/images/get_it_on_iTunes_apps_" + twoLetterCode + ".png";
      }
    }
    else if (this.store === "amazon") {
      return "./assets/images/available_at_amazon_" + twoLetterCode + ".png";
    }
    else if (this.store === "vudu") {
      return "./assets/images/vudu_btn.png";
    }
    else if (this.store === "googlePlay") {
      return "./assets/images/getItOn_googlePlay.png";
    }

    return "";
  }

  getAppleMusicButtonImageUrl(): string {
    return "./assets/images/listen_on_apple.png";
  }

  mediaIsMusic(): boolean {
    return Global.getMediaType() == Global.ALBUMS || Global.getMediaType() == Global.SINGLES;
  }

  getAdvisoryRatingIconUrl() {
    let ar = new String(this.item.advisoryRating);
    if(ar == "nrFamilyFriendly") { ar = "nr"; }
    let advisoryRating: string = ar.replace('-', '').toLowerCase();
    advisoryRating = advisoryRating.split(' ')[0];
    let iconUrl = "./assets/images/" + advisoryRating;
    if(this.themeService.isDarkTheme()) {
      iconUrl += "_white";
    }
    return iconUrl + ".png";
  }

  shouldOpenInNewTab(event): boolean {
    if (event && (event.which === 2 || event.metaKey || event.ctrlKey)) {
      return true;
    }
    else {
      return false;
    }
  }

  getSongCount(): number {
    return this.item.childSingles.length;
  }

  singleClicked(data) {
    if (data.single) {
      const id = data.single.idInStore || data.single.itemID;
      if (id) {

        //First load the data and check if it returns something
        this.loadData("singles", id).subscribe(res => {
          if (res.results && res.results.singles != null) {

            //If it returns something, go to the detail view
            const url = this.store + "/" + this.country + "/" +
              this.getString("singlesUrl") + "/" + id;

            if (this.shouldOpenInNewTab(data.event)) {
              window.open(url);
            }
            else {
              this.router.navigate([url]);
            }

          }
          //if it returns nothing, go directly to the product page
          else {
            this.showLoading = false;
            if (this.item && this.item.productPageUrl) {
              window.open(this.getProductPageUrl(this.item.productPageUrl), "blank");
            }
          }
        }, err => {
          this.showLoading = false;
          if (this.item && this.item.productPageUrl) {
            window.open(this.getProductPageUrl(this.item.productPageUrl), "blank");
          }
        });
      }
    }
  }

  getProductPageUrl(url): string {
    //Validate the url because sometimes it looks like this : &at=1l3v4gB
    //And this is not valid
    if (ValidationHelper.isValidUrl(url)) {
      if (this.store === Global.ITUNES) {
        if(this.mediaIsMusic()) {
          url += "&app=itunes";
        }
        return url + "&ct=website";
      }
      return url;
    }
    return "";
  }

  getAppleMusicProductPageUrl(url): string {
    if (ValidationHelper.isValidUrl(url)) {
      if (this.store === Global.ITUNES) {
        return url + "&app=music&ct=website";
      }
      return url;
    }
    return "";
  }

  wishlistStarClicked(e) {
    // Prevent multiple clicks while loading
    if (this.wishlistLoading) {
      return;
    }

    const cache = Cache.getInstance();
    cache.deleteEntriesWithKey("wishlist");

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (sessionToken) {

      let pluralItemType = Global.getPluralItemType(this.item.itemType);
      if (pluralItemType) {

        if (pluralItemType === "movies") {
          const detailViewMediaType = StorageHelper.getInstance().get(StorageHelper.keys.detailViewMediaType);
          if (detailViewMediaType === Global.RENTALMOVIES) {
            pluralItemType = Global.RENTALMOVIES;
          }
          else {
            pluralItemType = Global.BUYMOVIES;
          }
        }

        const id = this.item.idInStore || this.item.itemID;

        // Start loading immediately (disables button)
        this.wishlistLoading = true;
        // Show spinner after 1 second delay
        setTimeout(() => {
          if (this.wishlistLoading) {
            this.wishlistSpinnerVisible = true;
          }
        }, 1000);

        if (this.isItemInWishlist()) {
          this.wishlistService.removeItem(this.country, this.store, pluralItemType,
            sessionToken, this.item.idInStore)
            .subscribe(res => {
              this.wishlistLoading = false;
              this.wishlistSpinnerVisible = false;

              if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
                Global.clearSaveUserInfos();
                this.authentication.openRegister();
              }
              else {
                //Success!
                this.updateLocalShortWishlist(sessionToken);
              }

            }, err => {
              this.wishlistLoading = false;
              this.wishlistSpinnerVisible = false;
              Log.getInstance().d(err);
              this.updateLocalShortWishlist(sessionToken);
              this.toastService.error(this.getString('listActionFailed'));
            });
        }
        else {
          const ignoreSdPrice = this.shouldIgnoreSdPrice(pluralItemType);
          this.wishlistService.addItem(this.country, this.store, pluralItemType,
            sessionToken, this.item.idInStore, ignoreSdPrice)
            .subscribe(res => {
              this.wishlistLoading = false;
              this.wishlistSpinnerVisible = false;

              if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
                StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
                this.authentication.openRegister();
              }
              else {
                //Success!
                this.updateLocalShortWishlist(sessionToken);
              }

            }, err => {
              this.wishlistLoading = false;
              this.wishlistSpinnerVisible = false;
              Log.getInstance().d(err);
              this.updateLocalShortWishlist(sessionToken);
              this.toastService.error(this.getString('listActionFailed'));
            });
        }
      }

    }
    else {
      this.authentication.openRegister();
    }

  }

  /**
   * Checks if SD price should be ignored when adding to wishlist.
   * Only applies to movies and TV seasons.
   */
  private shouldIgnoreSdPrice(itemType: string): boolean {
    const setting = StorageHelper.getInstance().get(StorageHelper.keys.ignoreSdPriceOnWishlist);
    // Default is true - only return false if explicitly set to false
    if (setting === false) {
      return false;
    }
    // Only apply to movies and TV seasons
    // Note: 'seasons' is the plural of 'season' itemType, 'tvseasons' is the plural of 'tvSeason' itemType
    const movieAndTvTypes = ['movies', 'buymovies', 'rentalmovies', 'seasons', 'tvseasons'];
    return movieAndTvTypes.indexOf(itemType.toLowerCase()) !== -1;
  }

  ownlistStarClicked(e) {
    // Prevent multiple clicks while loading
    if (this.ownlistLoading) {
      return;
    }

    const cache = Cache.getInstance();
    cache.deleteEntriesWithKey("ownlist");

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (sessionToken) {

      let pluralItemType = Global.getPluralItemType(this.item.itemType);
      if (pluralItemType) {

        if (pluralItemType === "movies") {
          const detailViewMediaType = StorageHelper.getInstance().get(StorageHelper.keys.detailViewMediaType);
          if (detailViewMediaType === Global.RENTALMOVIES) {
            pluralItemType = Global.RENTALMOVIES;
          }
          else {
            pluralItemType = Global.BUYMOVIES;
          }
        }

        const id = this.item.idInStore || this.item.itemID;

        // Start loading immediately (disables button)
        this.ownlistLoading = true;
        // Show spinner after 1 second delay
        setTimeout(() => {
          if (this.ownlistLoading) {
            this.ownlistSpinnerVisible = true;
          }
        }, 1000);

        if (this.isItemInOwnlist()) {
          this.ownlistService.removeItem(this.country, this.store, pluralItemType,
            sessionToken, this.item.idInStore)
            .subscribe(res => {
              this.ownlistLoading = false;
              this.ownlistSpinnerVisible = false;

              if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
                Global.clearSaveUserInfos();
                this.authentication.openRegister();
              }
              else {
                //Success!
                this.updateLocalShortOwnlist(sessionToken);
              }

            }, err => {
              this.ownlistLoading = false;
              this.ownlistSpinnerVisible = false;
              Log.getInstance().d(err);
              this.updateLocalShortOwnlist(sessionToken);
              this.toastService.error(this.getString('listActionFailed'));
            });
        }
        else {
          this.ownlistService.addItem(this.country, this.store, pluralItemType,
            sessionToken, this.item.idInStore)
            .subscribe(res => {
              this.ownlistLoading = false;
              this.ownlistSpinnerVisible = false;

              if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
                StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
                this.authentication.openRegister();
              }
              else {
                //Success!
                this.updateLocalShortOwnlist(sessionToken);
              }

            }, err => {
              this.ownlistLoading = false;
              this.ownlistSpinnerVisible = false;
              Log.getInstance().d(err);
              this.updateLocalShortOwnlist(sessionToken);
              this.toastService.error(this.getString('listActionFailed'));
            });
        }
      }

    }
    else {
      this.authentication.openRegister();
    }
  }

  updateLocalShortWishlist(sessionToken: string) {

    if (!sessionToken) {
      return;
    }

    this.wishlistService.getShortWishlist(
      this.country,
      this.store,
      sessionToken
    ).subscribe(res => {

      if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openRegister();
      }
      else if (res && res["results"]) {
        const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
        shortWishlist[this.store] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        if (saved) {
          ListHelper.clearWishlistCache();
          this.updateListStates();
          // Update the price alert display after wishlist is loaded
          this.updatePriceAlertDisplayCache();
        } else {
          Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
        }
      }
    },
    err => {
      Log.getInstance().d(err);
    });
  }

  updateLocalShortOwnlist(sessionToken: string) {
    if (!sessionToken) {
      return;
    }

    this.ownlistService.getShortItemList(
      sessionToken, this.store, this.country
    ).subscribe(res => {

      if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openRegister();
      }
      else if (res && res["results"]) {
        const shortOwnlist = StorageHelper.getInstance().get(StorageHelper.keys.shortOwnlist) || {};
        shortOwnlist[this.store] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortOwnlist, shortOwnlist);
        if (saved) {
          ListHelper.clearOwnlistCache();
          this.updateListStates();
        } else {
          Log.getInstance().d('Failed to save ownlist to storage - storage may be full');
        }
      }
    },
      err => {
        Log.getInstance().d(err);
      });
  }

  /** @deprecated Use inWishlist property instead for template bindings */
  isItemInWishlist(): boolean {
    return this.inWishlist;
  }

  /** @deprecated Use inOwnlist property instead for template bindings */
  isItemInOwnlist(): boolean {
    return this.inOwnlist;
  }

  getScreenshots(itemScreens: string, itemScreensiPad: string): Array<string> {
    let screenshotsArray = [];
    if (itemScreens) {
      screenshotsArray = screenshotsArray.concat(itemScreens.split(','));
    }
    if (itemScreensiPad) {
      screenshotsArray = screenshotsArray.concat(itemScreensiPad.split(','));
    }
    return screenshotsArray;
  }

  /**
   * Safely returns screenshot images from item. Handles null item and both API formats:
   * - itemScreens/itemScreensiPad (comma-separated strings)
   * - screenshots (array, used by games API)
   * Prevents "Cannot read properties of null (reading 'screenshots')" crash.
   */
  getScreenshotsFromItem(item: any): string[] {
    if (!item) {
      return [];
    }
    if (item.screenshots && Array.isArray(item.screenshots) && item.screenshots.length > 0) {
      return item.screenshots;
    }
    return this.getScreenshots(item.itemScreens, item.itemScreensiPad);
  }

  getFileSize(fs: string): string {
    if (fs) {
      const fileSize: number = Number.parseInt(fs);
      if (fileSize) {
        const fileSizeInMB: number = fileSize / 1000000;
        return fileSizeInMB.toFixed(1) + " MB";
      }
      return "";
    }
    return "";
  }

  getPlatformName(platform: string): string {
    if (platform === Global.DEVICE_TYPE_ALL) {
      return this.getString("iPhoneiPad");
    }
    if (platform === Global.DEVICE_TYPE_IPAD) {
      return this.getString("iPad");
    }
    if (platform === Global.DEVICE_TYPE_IPHONE) {
      return this.getString("iPhone");
    }
    if (platform === Global.DEVICE_TYPE_MAC) {
      return this.getString("mac");
    }
    return "";
  }

  getPriceTrendTitle(): string {
    const lang = InternationalizationHelper.getTwoCharactersLanguage();
    let title = this.item.title;
    const provider = this.getProperProviderLabel();
    let returnValue = "Price Trend";

    if (!title) {
      title = "";
    }

    if (title && title.length > 80) {
      title = title.substring(0, 80) + "...";
    }


    switch (lang) {
      case "en":
        returnValue = `Price Trend of ${title} on ${provider}`;
        break;
      case "de":
        returnValue = `Preisverlauf von ${title} auf ${provider}`;
        break;
      case "fr":
        returnValue = `Tendance des prix de ${title} sur ${provider}`;
        break;
      case "es":
        returnValue = `Tendencia de precios de ${title} en ${provider}`;
        break;
      default:
        returnValue = `Price Trend of ${title} on ${provider}`;
        break;
    }

    return returnValue;
  }

  calculatePriceInsight(): { message: string, cssClass: string } | false {
    const ENABLE_LOGS = false;

    if (!this.item) {
      if (ENABLE_LOGS) console.log('[Debug] No item found. Returning false.');
      return false;
    }

    const itemName = this.item.title;
    const provider = this.getProperProviderLabel();

    if (ENABLE_LOGS) console.log(`[Debug] Processing item: ${itemName} from provider: ${provider}`);

    const relevantPriceInfo = PriceHelper.getRelevantPrice(this.item, true);
    if (!relevantPriceInfo) {
      if (ENABLE_LOGS) console.log('[Debug] No relevant price info found. Returning false.');
      return false;
    }

    const { price: currentPrice, type, isPriceDrop } = relevantPriceInfo;
    const formattedCurrentPrice = this.formatPrice(currentPrice, this.item.currency);

    const lowestInfo = PriceHelper.getLowestPriceInfo(this.item);
    if (!lowestInfo) {
      if (ENABLE_LOGS) console.log('[Debug] No price reductions found. Item is at its initial price.');
      return {
        message: this.getString('price_no_reductions', {
          itemName,
          provider,
          currentPrice: formattedCurrentPrice,
        }),
        cssClass: 'no-reduction',
      };
    }

    const { lowestPrice, date, timesReached } = lowestInfo;
    const formattedLowestPrice = this.formatPrice(lowestPrice, this.item.currency);
    const timesReachedString = timesReached.toString();

    const isBestPrice = PriceHelper.isBestPriceForItem(this.item);
    const isLowestPrice = PriceHelper.isLowestPriceForItem(this.item);
    const firstReachedDate = PriceHelper.getFirstReachedDate(this.item, currentPrice);
    const formattedFirstReachedDate = firstReachedDate ? DateHelper.serverDateToLocaleDate(firstReachedDate) : null;
    const formattedDate = DateHelper.serverDateToLocaleDate(date);

    if (isPriceDrop && !isBestPrice && !isLowestPrice) {
      const difference = Math.abs(lowestPrice - currentPrice).toFixed(2);
      const formattedDifference = this.formatPrice(Number(difference), this.item.currency);
      return {
        message: this.getString('price_reduction', {
          itemName,
          provider,
          currentPrice: formattedCurrentPrice,
          lowestPrice: formattedLowestPrice,
          lowestPriceDate: formattedDate,
          priceDifference: formattedDifference,
        }),
        cssClass: 'price-reduction-bg',
      };
    }

    if (isPriceDrop && isBestPrice) {
      return {
        message: this.getString('price_best_price', {
          itemName,
          provider,
          currentPrice: formattedCurrentPrice,
        }),
        cssClass: 'best-price-bg',
      };
    }

    if (isPriceDrop && isLowestPrice) {
      return {
        message: this.getString('price_lowest_price', {
          itemName,
          provider,
          currentPrice: formattedCurrentPrice,
          firstReachedDate: formattedFirstReachedDate,
          timesReached: timesReachedString,
        }),
        cssClass: 'lowest-price-bg',
      };
    }

    if (!isPriceDrop) {
      const difference = (currentPrice - lowestPrice).toFixed(2);
      const formattedDifference = this.formatPrice(Number(difference), this.item.currency);
      return {
        message: this.getString('price_increase', {
          itemName,
          provider,
          currentPrice: formattedCurrentPrice,
          lowestPrice: formattedLowestPrice,
          priceDifference: formattedDifference,
        }),
        cssClass: 'price-increase-bg',
      };
    }

    return {
      message: this.getString('price_fallback', {
        itemName,
        provider,
        currentPrice: formattedCurrentPrice,
      }),
      cssClass: 'no-reduction-bg',
    };
  }

  getCountry(): string {
    return this.country;
  }

  formatPrice(price: number, currency: string): string {
    if (price && currency) {
      return PriceHelper.formatPrice(price, currency);
    }
    else {
      return "";
    }
  }

  useIvan(): boolean {
    return Config.useIvan;
  }

  storeIsItunes(): boolean {
    return this.store == Global.ITUNES;
  }

  storeIsAmazon(): boolean {
    return Global.getStore() == Global.AMAZON;
  }

  openFullscreenGallery(i) {
    this.fullscreenGalleryPosition = i;
    this.fullscreenGalleryIsOn = true;
  }

  getCSVFromArray(array, key) {
    if (!array) {
      return "";
    }
    const tmpArray = [];
    for (const el of array) {
      tmpArray.push(el[key]);
    }
    return tmpArray.join(", ");
  }

  onBundleClick(e: any, bundle?: any) {
    if (!e && !bundle) {
      console.warn('onBundleClick called without event or bundle');
      return;
    }
    const actualEvent = (e && e.event) || e;
    const actualBundle = (e && e.bundle) || bundle || (this.item.parentMovieBundles && this.item.parentMovieBundles.length > 0 ? this.item.parentMovieBundles[0] : this.item.parentMovieBundle[0]);

    const id = actualBundle && (actualBundle.idInStore || actualBundle.itemID);
    if (id) {
      const url = this.country + "/" + this.store + "/" +
        this.getString(Global.getMediaTypeForDetailView() + "Url") + "/" + id + '/' + StringHelper.slugify(actualBundle.title);

      if (this.shouldOpenInNewTab(actualEvent)) {
        window.open(url);
      } else {
        this.router.navigate([url]);
      }
    }
  }

  buyButtonClick() {
    if((<any>window).gtag) {
      (<any>window).gtag('event', 'StoreClick', {
        'event_category': 'DetailView',
        'event_label': this.store + " | " + this.itemType
      });
    }
    if ((<any>window)._paq) {
      (<any>window)._paq.push(['trackEvent', "DetailView", "StoreClick", this.store + " | " + this.itemType]);
    }

    const randomNumber = String(Math.random() * 10000000000000000);
    //Event snippet for Click On iTunes Button conversion page In your html page, add the snippet and call gtag_report_conversion when someone clicks on the chosen link or button.
    (<any>window).gtag('event', 'conversion', {
      'send_to': 'AW-974225369/l38UCLSesrUBENn_xdAD',
      'transaction_id': randomNumber,
      'event_callback': function(){}
    });


  }

  hasMultiplePrices(): boolean {
    const priceEvo = this.getPriceEvolution();
    if (!priceEvo) { return false; }
    const parts = priceEvo.split('~');
    // Filter out empty parts
    const validParts = parts.filter(p => p && p.trim() !== '');
    return validParts.length > 1;
  }

  getPriceEvoDataForGraph(): GraphData {
    const labels = [];
    const points = [];
    const priceEvo = this.getPriceEvolution();
    if (!priceEvo) { return null; }
    const parts = priceEvo.split('~');
    let smallestPriceIndex = 0;
    let smallestPrice = Number.POSITIVE_INFINITY;
    for (let i = 0; i < parts.length; i++) {
      const p = parts[i];
      if (p) {
        const date = new Date(p.split(':')[0]);
        const indicator = p.split(':')[1][0];
        let price = p.split(':')[1];
        if (indicator === '+' || indicator === '-') {
          price = price.substring(1);
        }
        const priceFloat = Number.parseFloat(price);
        if (priceFloat <= smallestPrice) {
          smallestPriceIndex = i;
          smallestPrice = priceFloat;
        }
        points.unshift({ y: price, x: date, indicator: indicator, isBest: false });
      }
    }
    if (points.length > 0) {
      points[points.length - 1 - smallestPriceIndex].isBest = true;
    }
    return new GraphData(labels, [points]);
  }

  showAmazonUS(): boolean {
    if(this.storeIsAmazon() && Global.getCountry() == "us" && !Config.showAmazonUS) {
      return false;
    }
    return true;
  }

  onDDItemSelected(item) {

  }

  togglePriceTrendLegend(event: Event) {
    event.stopPropagation();
    this.priceTrendLegendVisible = !this.priceTrendLegendVisible;
  }

  showPriceTrendLegend() {
    if (!this.isMobile) {
      this.priceTrendLegendVisible = true;
    }
  }

  hidePriceTrendLegend() {
    if (!this.isMobile) {
      this.priceTrendLegendVisible = false;
    }
  }

  closePopup() {
    this.priceTrendLegendVisible = false;
  }

  getWishlistLabel() {
    let mediaType = StorageHelper.getInstance().get(StorageHelper.keys.detailViewMediaType);
    let label;

    label = this.getString('addToWishlist');

    if (mediaType == Global.RENTALMOVIES) {
      label = label + " (" + this.getString('toRent') + ")";
    }

    return label;
  }

  getFirstDirectorName(): string {
    if (this.item && this.item.directors && this.item.directors.length > 0) {
      return this.item.directors[0].name || '';
    }
    return '';
  }

  getProperProviderLabel(): string {
    let provider = Global.getStore();
    const mediaType = Global.getMediaTypeForSelector();

    if (provider === 'itunes') provider = 'Apple TV';
    if (provider === 'googlePlay') provider = 'Google Play';
    if (provider === 'amazon') provider = 'Amazon Prime Video';
    if (provider === 'vudu') provider = 'Fandango at Home';

    if ((mediaType == "audiobooks" || mediaType == "ebooks") && provider == "Apple TV") {
      provider = "Apple Books";
    }

    if ((mediaType == "apps" || mediaType == "macapps") && provider == "Apple TV") {
      provider = "App Store";
    }

    if (mediaType == "music" && provider == "Apple TV") {
      provider = "Apple Music";
    }

    return provider;
  }

  copyItunesLink(): void {
    let iTunesLink = this.item.iTunesUrl;

    navigator.clipboard.writeText(iTunesLink).then(() => {
      this.closeDropdown(this.moreDDContent);
    }).catch(err => {
      this.closeDropdown(this.moreDDContent);
    });

  }

  get parentBundles() {
    return this.item.parentMovieBundles || this.item.parentMovieBundle || [];
  }

  onChildMovieWishlistAction(event: { movie: any, action: 'add' | 'remove' }): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    const movie = event.movie;
    const id = movie.idInStore || movie.itemID;
    let pluralItemType = Global.getPluralItemType(movie.itemType || 'movie');
    if (pluralItemType === 'movies') {
      pluralItemType = Global.BUYMOVIES;
    }

    if (event.action === 'remove') {
      this.wishlistService.removeItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortWishlist(sessionToken), err => Log.getInstance().d(err));
    } else {
      const ignoreSdPrice = this.shouldIgnoreSdPrice(pluralItemType);
      this.wishlistService.addItem(this.country, this.store, pluralItemType, sessionToken, id, ignoreSdPrice)
        .subscribe(() => this.updateLocalShortWishlist(sessionToken), err => Log.getInstance().d(err));
    }
  }

  onChildMovieOwnlistAction(event: { movie: any, action: 'add' | 'remove' }): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    const movie = event.movie;
    const id = movie.idInStore || movie.itemID;
    let pluralItemType = Global.getPluralItemType(movie.itemType || 'movie');
    if (pluralItemType === 'movies') {
      pluralItemType = Global.BUYMOVIES;
    }

    if (event.action === 'remove') {
      this.ownlistService.removeItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortOwnlist(sessionToken), err => Log.getInstance().d(err));
    } else {
      this.ownlistService.addItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortOwnlist(sessionToken), err => Log.getInstance().d(err));
    }
  }

  onSeasonWishlistAction(event: { item: any, action: 'add' | 'remove' }): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    const season = event.item;
    const id = season.idInStore || season.itemID;
    const pluralItemType = Global.getPluralItemType(season.itemType || 'tvSeason');

    if (event.action === 'remove') {
      this.wishlistService.removeItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortWishlist(sessionToken), err => Log.getInstance().d(err));
    } else {
      const ignoreSdPrice = this.shouldIgnoreSdPrice(pluralItemType);
      this.wishlistService.addItem(this.country, this.store, pluralItemType, sessionToken, id, ignoreSdPrice)
        .subscribe(() => this.updateLocalShortWishlist(sessionToken), err => Log.getInstance().d(err));
    }
  }

  onSeasonOwnlistAction(event: { item: any, action: 'add' | 'remove' }): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    const season = event.item;
    const id = season.idInStore || season.itemID;
    const pluralItemType = Global.getPluralItemType(season.itemType || 'tvSeason');

    if (event.action === 'remove') {
      this.ownlistService.removeItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortOwnlist(sessionToken), err => Log.getInstance().d(err));
    } else {
      this.ownlistService.addItem(this.country, this.store, pluralItemType, sessionToken, id)
        .subscribe(() => this.updateLocalShortOwnlist(sessionToken), err => Log.getInstance().d(err));
    }
  }

  // ========== Price Alert Methods ==========

  /** Checks if the current item supports price alerts (movies, TV seasons, music, books, apps) */
  supportsPriceAlert(): boolean {
    if (!this.item) {
      return false;
    }
    const itemType = this.item.itemType;
    // Supported item types for price alerts
    const supportedTypes = [
      'movie',      // Movies
      'tvSeason',   // TV Seasons (alternative name)
      'season',     // TV Seasons
      'album',      // Music albums
      'song',       // Music singles/songs
      'single',     // Music singles (alternative name)
      'audiobook',  // Audiobooks
      'ebook',      // eBooks
      'app',        // iOS Apps
      'macapp'      // Mac Apps
    ];
    return supportedTypes.indexOf(itemType) !== -1;
  }

  /** Returns true if the item is a movie (for Buy/Rent selection) */
  isMovieItem(): boolean {
    return this.item && this.item.itemType === 'movie';
  }

  /**
   * Returns the correct itemType for wishlist API calls based on the item's type.
   * Handles the special case of movies (buymovies/rentalmovies) and music (albums/singles).
   */
  private getWishlistItemType(purchaseType: 'buy' | 'rent'): string {
    if (!this.item || !this.item.itemType) {
      return '';
    }

    const itemType = this.item.itemType;

    switch (itemType) {
      case 'movie':
        // Movies have buy/rent distinction
        return purchaseType === 'rent' ? Global.RENTALMOVIES : Global.BUYMOVIES;
      case 'season':
      case 'tvSeason':
        return Global.SEASONS;
      case 'album':
        return 'albums';
      case 'song':
      case 'single':
        return 'singles';
      case 'audiobook':
        return 'audiobooks';
      case 'ebook':
        return 'ebooks';
      case 'app':
        return 'apps';
      case 'macapp':
        return 'macapps';
      default:
        // Fallback: add 's' to make plural
        return itemType + 's';
    }
  }

  openPriceAlertModal(): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    if (this.priceAlertModal) {
      this.priceAlertModal.open();
    }
  }

  getPriceAlertDisplayPrice(): string {
    return this.priceAlertDisplayPriceCache;
  }

  /**
   * Safely converts a price value to string. Prevents "Cannot read properties of undefined (reading 'toString')" crash.
   */
  private safePriceToString(val: any, fallback: string): string {
    if (val === null || val === undefined) {
      return fallback;
    }
    if (typeof val === 'number' && isNaN(val)) {
      return fallback;
    }
    return String(val);
  }

  onPriceAlertSave(settings: PriceAlertSettings): void {
    this.priceAlertSettings = settings;

    if (!this.item) {
      this.priceAlertSaving = false;
      return;
    }

    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      this.authentication.openRegister();
      return;
    }

    // Start loading - show spinner on price alert card
    this.priceAlertSaving = true;

    // Determine itemType based on item type and purchaseType selection
    const itemType = this.getWishlistItemType(settings.purchaseType);

    // Check if this is a single-price item (no SD/HD distinction)
    const isSinglePriceItem = this.item.price != null && this.item.priceHd == null && this.item.priceSd == null;

    let customPrice: string;
    let customPriceHd: string;

    if (isSinglePriceItem) {
      // For single-price items (music, apps, books), use single price settings
      if (settings.singlePriceOption === 'custom' && settings.singleCustomPrice != null) {
        customPrice = this.safePriceToString(settings.singleCustomPrice, '0');
      } else {
        // 'under' option - use current price
        customPrice = this.item && this.item.price != null ? this.safePriceToString(this.item.price, '0') : '0';
      }
      // No HD price for single-price items - don't send it
      customPriceHd = undefined;
    } else {
      // For video items (movies, TV) with SD/HD prices
      // Calculate customPrice (SD) - use -1 if ignored
      if (settings.sdPriceOption === 'ignore') {
        customPrice = '-1';
      } else if (settings.sdPriceOption === 'custom' && settings.sdCustomPrice != null) {
        customPrice = this.safePriceToString(settings.sdCustomPrice, '-1');
      } else {
        // 'under' option - use current SD price
        customPrice = this.item && this.item.priceSd != null ? this.safePriceToString(this.item.priceSd, '-1') : '-1';
      }

      // Calculate customPriceHd
      if (settings.hdPriceOption === 'custom' && settings.hdCustomPrice != null) {
        customPriceHd = this.safePriceToString(settings.hdCustomPrice, '0');
      } else {
        // 'under' option - use current HD price
        customPriceHd = this.item && this.item.priceHd != null ? this.safePriceToString(this.item.priceHd, '0') : '0';
      }
    }

    // Calculate customPrice4k (Vudu only) - no ignore option for 4K
    let customPrice4k: string = undefined;
    if (this.store === Global.VUDU) {
      const current4kPrice = settings.purchaseType === 'rent' ? this.item.rentalPrice4k : this.item.price4k;
      if (settings.fourKPriceOption === 'custom' && settings.fourKCustomPrice != null) {
        customPrice4k = this.safePriceToString(settings.fourKCustomPrice, '0');
      } else {
        // 'under' option - use current 4K price
        customPrice4k = current4kPrice != null ? this.safePriceToString(current4kPrice, '0') : '0';
      }
    }

    const idInStore = this.item.idInStore || this.item.itemID;

    // Make API call to save custom prices
    this.wishlistService.setCustomPrice(
      this.country,
      this.store,
      itemType,
      idInStore,
      customPrice,
      customPriceHd,
      sessionToken,
      customPrice4k
    ).subscribe(
      res => {
        // Check for success (API returns "success" string or success field)
        const isSuccess = res && (res['success'] === true || res['success'] === 'true' || res === 'success' || res['message'] === 'success');
        if (isSuccess || (res && !res['error'])) {
          Log.getInstance().d({ message: 'Price alert saved successfully', response: res });
          // Reload the short wishlist to get updated custom prices
          this.reloadWishlistAndUpdateDisplay(sessionToken);
        } else {
          Log.getInstance().d({ message: 'Price alert save failed', response: res });
          this.priceAlertSaving = false;
        }
      },
      err => {
        Log.getInstance().d({ message: 'Price alert save error', error: err });
        this.priceAlertSaving = false;
      }
    );
  }

  reloadWishlistAndUpdateDisplay(sessionToken: string): void {
    if (!sessionToken) {
      this.priceAlertSaving = false;
      return;
    }

    this.wishlistService.getShortWishlist(
      this.country,
      this.store,
      sessionToken
    ).subscribe(res => {
      this.priceAlertSaving = false;
      if (res && res["message"] === BaseService.COULDNT_LOAD_USER) {
        StorageHelper.getInstance().clear(StorageHelper.keys.sessionToken);
        this.authentication.openRegister();
      } else if (res && res["results"]) {
        const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
        shortWishlist[Global.getStore()] = res["results"];
        const saved = StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        if (saved) {
          ListHelper.clearWishlistCache();
          // Update the cached display price
          this.updatePriceAlertDisplayCache();
          Log.getInstance().d({ message: 'Wishlist reloaded, display updated' });
        } else {
          Log.getInstance().d('Failed to save wishlist to storage - storage may be full');
        }
      }
    },
      err => {
        this.priceAlertSaving = false;
        Log.getInstance().d(err);
      });
  }

  updatePriceAlertDisplayCache(): void {
    // Get custom prices and isRental from wishlist (v2 API)
    const wishlistData = ListHelper.getWishlistCustomPrices(this.item, this.store);

    // If no wishlist data available, load it from API
    if (wishlistData.initialHdPriceValue === null && wishlistData.initialPriceValue === null) {
      this.loadWishlistDataAndUpdateDisplay();
      return;
    }

    this.priceAlertIsRental = wishlistData.isRental;
    this.priceAlertDisplayPriceCache = this.calculatePriceAlertDisplayPrice(wishlistData);
    this.priceAlertPricesCache = this.calculatePriceAlertPrices();
  }

  loadWishlistDataAndUpdateDisplay(): void {
    const sessionToken = StorageHelper.getInstance().get(StorageHelper.keys.sessionToken);
    if (!sessionToken) {
      return;
    }

    this.wishlistService.getShortWishlist(
      this.country,
      this.store,
      sessionToken
    ).subscribe(res => {
      if (res && res["results"]) {
        const shortWishlist = StorageHelper.getInstance().get(StorageHelper.keys.shortWishlist) || {};
        shortWishlist[Global.getStore()] = res["results"];
        StorageHelper.getInstance().save(StorageHelper.keys.shortWishlist, shortWishlist);
        ListHelper.clearWishlistCache();

        // Now update the display with the loaded data
        const wishlistData = ListHelper.getWishlistCustomPrices(this.item, this.store);
        this.priceAlertIsRental = wishlistData.isRental;
        this.priceAlertDisplayPriceCache = this.calculatePriceAlertDisplayPrice(wishlistData);
        this.priceAlertPricesCache = this.calculatePriceAlertPrices();
      }
    },
      err => {
        Log.getInstance().d(err);
      });
  }

  calculatePriceAlertDisplayPrice(wishlistData?: { initialPriceValue: number | null, initialHdPriceValue: number | null, initial4kPriceValue: number | null, hasCustomPrice: boolean, isRental: boolean }): string {
    if (!this.item) {
      return '---';
    }

    // Get wishlist data from API if not provided
    if (!wishlistData) {
      wishlistData = ListHelper.getWishlistCustomPrices(this.item, this.store);
    }

    const parts: string[] = [];
    // SD is ignored if initialPriceValue is -1
    const sdIgnored = wishlistData.initialPriceValue === -1;
    // Check if price types exist
    const has4k = this.store === Global.VUDU && wishlistData.initial4kPriceValue !== null;
    const hasHd = wishlistData.initialHdPriceValue !== null;
    const hasSd = wishlistData.initialPriceValue !== null && !sdIgnored;

    // SD price is only shown in detail view if there's NO HD and NO 4K price
    // (i.e., the item only has SD price)
    const showSdInDetailView = hasSd && !hasHd && !has4k;

    // Check if we need labels (multiple prices displayed)
    const multiplePrices = (has4k ? 1 : 0) + (hasHd ? 1 : 0) + (showSdInDetailView ? 1 : 0) > 1;

    // 4K Price (initial4kPriceValue) - Vudu only
    if (has4k) {
      const fourKPrice = PriceHelper.formatPrice(wishlistData.initial4kPriceValue, this.item.currency);
      parts.push(multiplePrices ? fourKPrice + ' (4K)' : fourKPrice);
    }

    // HD Price (initialHdPriceValue)
    if (hasHd) {
      const hdPrice = PriceHelper.formatPrice(wishlistData.initialHdPriceValue, this.item.currency);
      parts.push(multiplePrices ? hdPrice + ' (HD)' : hdPrice);
    }

    // SD Price (initialPriceValue) - only shown if item ONLY has SD price (no HD, no 4K)
    if (showSdInDetailView) {
      const sdPrice = PriceHelper.formatPrice(wishlistData.initialPriceValue, this.item.currency);
      parts.push(sdPrice);
    }

    if (parts.length > 0) {
      return parts.join(' / ');
    }

    return '---';
  }

  onPriceAlertRemove(): void {
    // Remove from wishlist when user clicks remove in the modal
    this.wishlistStarClicked(null);
  }

  // Returns cached price alert data for display in the card (prevents flickering)
  getPriceAlertPrices(): { quality: string, price: string }[] {
    return this.priceAlertPricesCache;
  }

  // Calculates structured price alert data
  calculatePriceAlertPrices(): { quality: string, price: string }[] {
    if (!this.item) {
      return [];
    }

    const wishlistData = ListHelper.getWishlistCustomPrices(this.item, this.store);
    const prices: { quality: string, price: string }[] = [];

    // Check if this is a video item (movie or TV season) - only these have SD/HD/4K quality
    const isVideoItem = this.item.itemType === 'movie' || this.item.itemType === 'season' || this.item.itemType === 'tvSeason';

    if (isVideoItem) {
      // SD is ignored if initialPriceValue is -1
      const sdIgnored = wishlistData.initialPriceValue === -1;
      // Check if price types exist
      const has4k = this.store === Global.VUDU && wishlistData.initial4kPriceValue !== null;
      const hasHd = wishlistData.initialHdPriceValue !== null;
      const hasSd = wishlistData.initialPriceValue !== null && !sdIgnored;

      // SD price is only shown if there's NO HD and NO 4K price
      const showSd = hasSd && !hasHd && !has4k;

      // 4K Price (Vudu only)
      if (has4k) {
        prices.push({
          quality: '4K',
          price: PriceHelper.formatPrice(wishlistData.initial4kPriceValue, this.item.currency)
        });
      }

      // HD Price (or HD/4K for iTunes movies with 4K support)
      if (hasHd) {
        // For iTunes movies with has4K = 1, show HD/4K label and 4K icon
        const isItunes4K = this.storeIsItunes() && this.item.has4K == 1;
        prices.push({
          quality: isItunes4K ? 'HD/4K' : 'HD',
          price: PriceHelper.formatPrice(wishlistData.initialHdPriceValue, this.item.currency)
        });
      }

      // SD Price - only if no other quality available
      if (showSd) {
        prices.push({
          quality: 'SD',
          price: PriceHelper.formatPrice(wishlistData.initialPriceValue, this.item.currency)
        });
      }
    } else {
      // Non-video items (music, apps, books) - just show price without quality label
      if (wishlistData.initialPriceValue !== null) {
        prices.push({
          quality: '',  // No quality label for non-video items
          price: PriceHelper.formatPrice(wishlistData.initialPriceValue, this.item.currency)
        });
      }
    }

    return prices;
  }

}
